import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    requestList: null,
    requestDetail: {},
    editUser: {},
    idDocument: '',
    email: ""
  },
  mutations: {
    setRequestDetail(state, payload){
      state.requestDetail = payload;
      console.log("nice");
    },
    setIdDocument(state, payload){
      state.idDocument = payload;
    },
    setRequestDataList(state, payload){
      state.requestList = payload;
    },
    setEditUser(state, payload){
      state.editUser = payload;
      console.log("nice");
    },
    login(state,email){
      state.email = email;
      localStorage.setItem('email',email);
    },
    logout(state){
      state.email = "";
      localStorage.removeItem('email');
    },
    initializeStore(state){
      if(localStorage.getItem('email')){
        state.email = localStorage.getItem('email')
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
